const routes = [
    {
        path: '/',
        redirect: '/home'
    },
    {
        path: "/login", // 登录
        name: "login",
        component: () => import("../pages/login/index.vue"),
    },
    {
        path: "/register", // 登录
        name: "register",
        component: () => import("../pages/login/register.vue"),
    },
    {
        path: "/switchLang", // 选择语言
        name: "switchLang",
        component: () => import("../pages/other/switchLang.vue"),
    },
    {
        path: "/message", // 信息
        name: "message",
        component: () => import("../pages/other/message.vue"),
    },
    {
        path: "/home", // 首页
        name: "home",
        component: () => import("../pages/tabbar/home.vue"),
    },
    {
        path: "/commodity", // 商品
        name: "commodity",
        component: () => import("../pages/tabbar/commodity.vue"),
    },
    {
        path: "/grabOrder", // 抢单
        name: "grabOrder",
        component: () => import("../pages/tabbar/grabOrder.vue"),
    },
    {
        path: "/customerService", // 客服
        name: "customerService",
        component: () => import("../pages/tabbar/customerService.vue"),
    },
    {
        path: "/mine", // 我的
        name: "mine",
        component: () => import("../pages/tabbar/mine.vue"),
    },
    {
        path: "/orderRecord", // 订单记录
        name: "orderRecord",
        component: () => import("../pages/wallet/orderRecord.vue"),
    },
    {
        path: "/recharge", // 充值
        name: "recharge",
        component: () => import("../pages/wallet/recharge.vue"),
    },
    {
        path: "/withdraw", // 提现
        name: "withdraw",
        component: () => import("../pages/wallet/withdraw.vue"),
    },
    {
        path: "/withdrawRecord", // 提现
        name: "withdrawRecord",
        component: () => import("../pages/wallet/withdrawRecord.vue"),
    },
    {
        path: "/fundingDetails", // 提现
        name: "fundingDetails",
        component: () => import("../pages/wallet/fundingDetails.vue"),
    },
    {
        path: "/bankCard", // 钱包
        name: "bankCard",
        component: () => import("../pages/wallet/bankCard.vue"),
    },
    {
        path: "/changePsd", // 修改密码
        name: "changePsd",
        component: () => import("../pages/wallet/changePsd.vue"),
    },
    {
        path: "/privacy", // 隐私
        name: "privacy",
        component: () => import("../pages/other/privacy.vue"),
    },
    {
        path: "/terms", // 条款
        name: "terms",
        component: () => import("../pages/other/terms.vue"),
    },
]

export default routes